module.exports = __webpack_public_path__ + "static/media/value.d1fc9bc2.svg";